<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="createEntity"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="entityId"
  >
    <template #field.price="{ item }">
      <v-text-field
        v-model.number="item.price"
        label="Цена за филиал в месяц"
        type="number"
        outlined
        required
        :rules="[v => !!v || 'Обязательное поле', v => v >= 0 || 'Цена не может быть отрицательной']"
      />
    </template>

    <template #field.description="{ item }">
      <v-textarea
        v-model="item.description"
        label="Описание"
        outlined
        auto-grow
        rows="3"
      />
    </template>

    <template #field.features="{ item }">
      <string-list-field
        v-model="item.features"
        label="Что входит в тариф"
        item-label="Пункт"
        add-text="Добавить пункт"
        empty-text="Пункты не заданы — блок состава тарифа в CRM не покажется"
        hint="Порядок сохраняется: на странице «Мой тариф» пункты идут по колонкам сверху вниз"
      />
    </template>
  </entity-edit-form>
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import StringListField from '@/components/ui/crud/fields/StringListField.vue'
  import ImageUploadField from '@/components/ui/crud/fields/ImageUploadField'
  import { VCheckbox, VTextField } from 'vuetify/lib'
  import TariffDataService from '@/services/api/TariffDataService'
  import RouteName from '@/models/enums/RouteName'

  export default {
    name: 'TariffForm',
    components: { EntityEditForm, StringListField },
    data () {
      return {
        dataService: TariffDataService,
        fields: [
          {
            key: 'name',
            label: 'Название',
            component: VTextField,
            defaultValue: null,
            rules: ['required'],
          },
          {
            key: 'price',
            label: 'Цена за филиал в месяц',
            defaultValue: null,
          },
          {
            key: 'description',
            label: 'Описание',
            defaultValue: null,
          },
          {
            key: 'image',
            label: 'Изображение тарифа',
            component: ImageUploadField,
            defaultValue: null,
          },
          {
            key: 'features',
            label: 'Что входит в тариф',
            defaultValue: [],
          },
          {
            key: 'isActive',
            label: 'Активен',
            component: VCheckbox,
            defaultValue: true,
          },
        ],
      }
    },
    computed: {
      listRouteName () {
        return RouteName.AdministrationTariffs
      },
      entityId () {
        return this.$route.params.id
      },
      createEntity () {
        return !this.entityId
      },
      title () {
        return this.createEntity ? 'Новый тариф' : 'Редактирование тарифа'
      },
    },
  }
</script>
